import React from 'react'
import { Box, ClickAwayListener, InputBase, Skeleton, Typography } from '@mui/material'
import Markdown from 'react-markdown'
import { flushSync } from 'react-dom'

function ClickAndEditText({
  value,
  onChange,
  editable = false,
  placeholder = '',
  sx = {},
  InputBaseProps = {},
  loading = false,
  colorDisabled = '#D0D5DD',
  markdown = false,
}) {
  const [editing, setEditing] = React.useState(false)
  const [localValue, setLocalValue] = React.useState(value || '')
  const [hover, setHover] = React.useState(false)

  const inputRef = React.useRef(null)

  React.useEffect(() => {
    if (!editing) {
      setLocalValue(value)
    }
  }, [value, editing])

  React.useEffect(() => {
    if (editing && inputRef.current) {
      const length = inputRef.current.value.length

      inputRef.current.setSelectionRange(length, length)
    }
  }, [editing])

  if (loading) {
    return <Skeleton height={50} variant="text" width="100%" />
  }

  const handleClickAway = () => {
    if (localValue !== value) {
      flushSync(() => {
        onChange(localValue)
      })
    }
    setEditing(false)
  }

  return (
    <Box
      sx={{ width: '100%' }}
      onClick={e => {
        e.preventDefault()
        e.stopPropagation()
      }}
    >
      {editing ? (
        <ClickAwayListener onClickAway={handleClickAway}>
          <InputBase
            autoFocus
            fullWidth
            inputRef={inputRef}
            placeholder={placeholder}
            sx={{ ...sx }}
            value={localValue}
            onChange={e => {
              const newValue = e.target.value

              setLocalValue(newValue)
              onChange(newValue)
            }}
            {...InputBaseProps}
          />
        </ClickAwayListener>
      ) : (
        <Box
          sx={{
            cursor: editable ? '' : 'default',
            transition: 'color 0.2s',
            '&:hover': {
              color: editable ? (hover ? '#000' : '#333') : 'inherit',
            },
          }}
          onClick={() => {
            if (!editable) return
            setEditing(true)
          }}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          {markdown ? (
            <Markdown>{localValue || placeholder}</Markdown>
          ) : localValue ? (
            <Typography sx={{ ...sx }}>{localValue}</Typography>
          ) : (
            <Typography sx={{ ...sx, color: colorDisabled }}>{placeholder}</Typography>
          )}
        </Box>
      )}
    </Box>
  )
}

export default ClickAndEditText
